<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="orange" icon="mdi-store" title="订单量" :value="infoData.orderNum+''" small-value="单"
          sub-icon="mdi-viewList-outline" :sub-text="`${params.startDate}至${params.endDate}商家总下单数量`" />
      </v-flex>
    

      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="green" icon="mdi-cash" title="成交额" :value="'￥' + infoData.orderCom"
          sub-icon="mdi-calendar" :sub-text="`${params.startDate}至${params.endDate}商家总成交额`" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="info" icon="mdi-angular" title="下单金额" :value="'￥' + infoData.orderAll"
          sub-icon="mdi-calendar" :sub-text="`${params.startDate}至${params.endDate}总下单额：包含未完成和退款`" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="red" icon="mdi-alert" title="退款金额" :value="'￥' + infoData.refundAll"
          sub-icon="mdi-calendar" :sub-text="`${params.startDate}至${params.endDate}商家退款总额`" />
      </v-flex>

      <v-flex md3 lg2>
        <v-text-field v-model="query.orderNum" label="订单编号" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>

      <v-flex md3 lg2>
        <v-text-field v-model="query.realname" label="顾客姓名" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>
      <v-flex md3 lg2>
        <v-text-field v-model="query.phone" label="顾客电话" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>

      <v-flex md3 lg2>
        <v-select v-model="query.shanghu_id" :disabled="query.s_type === 1 || query.s_type === 2 || query.ru_id !=''" 
        :items="merchantList" label="所属商家" item-text="s_name" item-value="_id"  @change="getList()"></v-select>
      </v-flex>
      <v-flex md3 lg2>
            <v-select v-model="query.ru_id" :items="restaurantList" label="餐厅名称"  item-text="server_name"
             item-value="id"  @change="getList()" ></v-select>
       </v-flex>

      <v-flex md3 lg2>
                <v-select v-model="query.s_type"
              :items="[ { label: '全部类别', value: '' }, { label: '大餐厅商户', value: 1 }, { label: '商业街商户', value: 2 }]"
              label="商户类别" item-text="label" item-value="value"  @change="getList()" ></v-select>
       </v-flex>

      <v-flex md3 lg2>
        <v-select v-model="query.status"
          :items="[{ label: '全部状态', value: '' }, { label: '待配送', value: 1 }, { label: '已完成', value: 2 }, { label: '已退款', value: 3 }]"
          label="订单状态" item-text="label" item-value="value" @change="getList()"></v-select>
      </v-flex>


      <v-flex md3 lg2>
        <div>
          <v-select v-model="query.pageSize" :items="pageSizes" item-text="label" @change="getList()" item-value="value"
            label="每页条数" class="pr-2 inline-block" required></v-select>
        </div>
      </v-flex>

      <v-flex md3 lg6>
        <el-date-picker v-model="params.startDate" value="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
          placeholder="选择开始日期"></el-date-picker>-
        <el-date-picker v-model="params.endDate" value="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
          placeholder="选择结束日期"></el-date-picker>
        <v-btn color="blue-grey" @click="getList()">查询</v-btn>
        <!-- <v-btn color="green" @click="exportExcel()">导出记录</v-btn> -->
        <v-btn color="green" @click="exportExcel123()">导出记录</v-btn>
        <v-btn color="green" @click="batchSendSms()">发送短信</v-btn>
      </v-flex>

      <!-- <v-flex xs-6 md-6 lg-6 sm-6>
        <v-btn color="gray" @click="resetSearch()">重置</v-btn>
        <v-btn color="dark" @click="getList()">
          <v-icon size="14">mdi-account-search</v-icon>&nbsp;搜索
        </v-btn>
      </v-flex> -->

    </v-layout>

    <v-divider></v-divider>

    <v-layout wrap justify-space-between>


    </v-layout>

    <v-layout row wrap>
      <v-flex xs-12 md-12 lg-12 sm-12>
        <el-table id="export-table1" ref="multipleTable" :data="items" tooltip-effect="dark" style="width: 100%" border v-loading="tableLoad"
          @selection-change="handleSelectionChange" >

          <el-table-column label="订单编号" prop="orderNum"></el-table-column>
          <el-table-column label="订单内容" prop="orderstr"></el-table-column>
          <el-table-column label="顾客姓名" prop="realname"></el-table-column>
          <el-table-column label="联系电话" prop="phone"></el-table-column>
          <el-table-column label="商家" prop="shanghu"></el-table-column>
          <el-table-column label="起点">
            <template slot-scope="scope">
              <div>{{ scope.row.qi }}</div>
            </template>
          </el-table-column>
          <el-table-column label="终点">
            <template slot-scope="scope">
              <div>{{ scope.row.mu }}</div>
            </template>
          </el-table-column>

          <el-table-column label="总金额">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.totalPrice).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="餐费额">
            <template slot-scope="scope">
              <div>￥{{ (Number(scope.row.totalPrice) - Number(scope.row.pei)).toFixed(2) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="配送费">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.pei).toFixed(2) }}</div>
            </template>
          </el-table-column>
                    
          <el-table-column label="来源">
            <template slot-scope="scope">
              <div  v-if="scope.row.pay_type ==0" > 微信 </div>
              <div  v-else>支付宝</div>
            </template>
          </el-table-column>
          <el-table-column label="所属餐厅">
            <template slot-scope="scope">
              <div>{{ scope.row.ru_name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop label="状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.status == 0">待付款</div>
                <div v-if="scope.row.status == 1">待配送</div>
                <div v-if="scope.row.status == 2">已完成</div>
                <div v-if="scope.row.status == 3">已退款</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop label="配送状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.help.state == 1">待骑手接单</div>
                <div v-if="scope.row.help.state == 2">骑手已接单</div>
                <div v-if="scope.row.help.state == 3">订单已完成</div>
                <div v-if="scope.row.help.state == 4">订单已退款</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="_createTime"></el-table-column>
          <el-table-column label="操作">

            <template slot-scope="scope">

              <!-- <v-btn small slot="activator" v-if="scope.row.status == 1" color="success" @click="confirmOrder(scope.row)">
                完成订单
              </v-btn> -->
              <v-btn small slot="activator"  v-if="userRole == 'admin'"   color="success" @click="confirmOrder(scope.row)">
                完成订单
              </v-btn>              

              <v-btn small slot="activator"  v-if="scope.row.status == 0" color="success" @click="checkPay(scope.row)">
                查询支付状态
              </v-btn>


              <!-- <v-btn small slot="activator" v-if="scope.row.status == 1 && scope.row.help.state == 1" color="danger"
                @click="cancelOrder(scope.row)">
                取消订单
              </v-btn> -->
              <!-- 不显示订单取消   -->
              <!-- <v-btn small slot="activator" v-if=" getuid !='7'  &&  scope.row.status != 4 && scope.row.help.state != 3" color="danger"
                @click="cancelOrder(scope.row)">
                取消订单
              </v-btn> -->
              <v-btn small slot="activator" v-if="userRole == 'admin'" color="warning" @click="cancelOrder(scope.row)">
                强制取消
              </v-btn>
            </template>
          </el-table-column>
          <el-table-column label="是否已发短信">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.sms_state == 1">是</div>
                <div v-if="scope.row.sms_state == 0">否</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column type="selection" label="选择" width="60"/>
        </el-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-end mt-3>
      <el-pagination @current-change="handleCurrentChange" :current-page="query.currentPage" :page-size="query.pageSize"
        layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
    </v-layout>

  </v-container>
</template>
<script>
// import detail from './OrderDetail'
// import Authority from './Authority'
import  * as XLSX from 'xlsx'
import fs from 'file-saver'
let _this;
export default {
  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    load(val) {
      if (val) {
        this.pageLoad = val
      }
    },
    pageLoad(val) {
      if (val) {
        this.getList();
      }
    }
  },
  data() {
    return {
      params: {
        startDate: '',
        endDate: ''
      },
      infoData: {
        orderNum: "0",
        orderCom: "0",
        orderAll: "0",
        refundAll: "0"
      },
      pageLoad: false,
      merchantList: [],
      restaurantList:[],
      userRole: sessionStorage.getItem('role'),
      getuid:sessionStorage.getItem('uid'),
      items: [],
      query: {
        shanghu_id:'',
        orderNum: '',
        status: '',
        realname: '',
        s_type:'',
        phone: '',
        ru_id:'',
        currentPage: 1,
        pageSize: 10
      },
      multipleSelection: [],
      selectedRows:[],
      pageSizes: this.$pageSizes,
      tableLoad: false,
      total: 0,
    };
  },
  mounted() {
    _this = this;
    this.getToday()
    this.getMerchantList()
    this.getrestaurantList();
    this.getList();
  },
  methods: {
    randomString(len) {
      len = len || 32
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      const maxPos = chars.length
      let str = ''
      for (let i = 0; i < len; i += 1) {
        str += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return str
    },
    formatTime(date){
     const time = date? new Date(date):new Date();
//   async formatTime(){
     //const time = new Date();
     const yyyy = time.getFullYear();
     const MM =String((time.getMonth()+1)).toString().padStart(2,'0');
     const dd=String(time.getDate().toString()).padStart(2,'0');
     const hh =String(time.getHours().toString()).padStart(2,'0');
     const mm =String(time.getMinutes().toString()).padStart(2,'0');
     const ss=String(time.getSeconds().toString()).padStart(2,'0');
     return `${yyyy}${MM}${dd}`;
   },
   async exportExcel123(){

    try {
        // 1. 定义你原有的导出参数（保持一致）
        const xlsxParam = {
          raw: true, // 保留原始数据格式，避免数字/日期自动转换
          dateNF: 'YYYY-MM-DD', // 日期格式（按需调整）
          skipHidden: true // 跳过隐藏的行/列
        };

        // 2. 获取表格并生成原始工作簿
        const table = document.querySelector('#export-table1');
        if (!table) {
          alert('未找到ID为 export-table1 的表格！');
          return;
        }
        let wb = XLSX.utils.table_to_book(table, xlsxParam);

        // 3. 获取工作簿中第一个工作表（默认表名是Sheet1）
        const sheetName = wb.SheetNames[0];
        const originalWs = wb.Sheets[sheetName];

        // 4. 将工作表转为二维数组（header:1 表示表头为第一行）
        const tableData = XLSX.utils.sheet_to_json(originalWs, { header: 1 });
        if (tableData.length <= 1) { // 只有表头无数据
          alert('表格无有效数据，无需导出！');
          return;
        }

        // 5. 计算合计值（核心逻辑：以“数量”“总价”列为例）
        const colLength = tableData[0].length; // 列总数
        const totalRow = new Array(colLength).fill('-'); // 初始化合计行
        totalRow[0] = '合计'; // 第一列显示“合计”
        // 6. 把合计行追加到数据最后一行
        const orderNum = Number(this.infoData.orderNum);
        const orderCom = Number(this.infoData.orderCom);
        const orderAll = Number(this.infoData.orderAll);
        const refund = Number(this.infoData.refundAll);
        totalRow[0] = '合计';
        totalRow[1] ='订单量:'+ orderNum;
        totalRow[2] ='成交额:'+ orderCom;
        totalRow[3] ='下单金额:'+ orderAll;
        totalRow[4] ='退款金额:'+ refund;
        tableData.push(totalRow);

        // 7. 重新生成工作表，替换原工作簿中的表
        const newWs = XLSX.utils.aoa_to_sheet(tableData);
        wb.Sheets[sheetName] = newWs;

        // 8. 生成并下载Excel文件
        const excelBuffer = XLSX.write(wb, {
          bookType: 'xlsx',
          type: 'array',
          compression: true // 开启压缩，减小文件体积
        });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `数据报表${this.formatTime(this.params.startDate)}-${this.formatTime(this.params.endDate)}.xlsx`);

        alert('Excel导出成功，已添加合计行！');
      } catch (error) {
        console.error('导出失败原因：', error);
        alert('导出失败，请检查控制台错误信息');
      }
   }, 
  
  async  batchSendSms() {
  // 1. 判断是否勾选数据
  if (this.selectedRows.length === 0) {
    alert('请先勾选需要发送短信的数据！')    
    return
  }

 // 2. 提取所有选中手机号
  const phoneArr = this.selectedRows.map(item => item.orderNum)
  
  // 3. 调用后端短信接口（这里替换你自己的请求）
  try {
     const res = await this.$post('sendsms/batchPhone',{ phones: phoneArr});
     if (res.data.length != 0) {
       // 发送完成清空勾选
      this.$refs.multipleTable.clearSelection();
      alert(`已成功向${phoneArr.length}个号码发起短信发送`)
     }
  } catch (err) {
    alert('短信发送失败，请稍后重试')
  }
 },


  // 方式1：导出DOM表格（直接匹配页面table，无需处理数据）
   //const table = document.getElementById('export-table1')
  // const wb = XLSX.utils.table_to_book(table)
  //方式2：导出数组数据（自定义表头，推荐灵活处理数据时用）
  // const wb = XLSX.utils.json_to_sheet(this.items, {
  //   header: ['姓名', '年龄'], // 自定义表头
  //   skipHeader: false
  //  })
  // 下载文件
  // XLSX.writeFile(wb, '人员信息.xlsx')

      //  try {
      //   // 1. 克隆数据（避免修改原数据）
        
      //  const exportData = JSON.parse(JSON.stringify(this.items))
      //   const orderCom = Number(this.infoData.orderNum);
      //   const refundAll = Number(this.infoData.orderCom);
      //   const orderAll = Number(this.infoData.orderAll);
      //   const refund = Number(this.infoData.refundAll);
      // const totalRow = {
      //     _id: '合计',       // 序号列显示“合计”
      //     _openid: orderCom,        // 商品名称列无数据，填“-”
      //     a_id: refundAll,       // 单价列无数据，填“-”
      //     avatar_url: orderAll,    // 总数量
      //     mu: refund // 总金额
      //   }

      //    exportData.push(totalRow);  
      // //   // 创建工作簿
      //  const worksheet = XLSX.utils.json_to_sheet(exportData)        
      //  const workbook = XLSX.utils.book_new()
      //   // 将工作表添加到工作簿，命名为"用户数据"
      //   XLSX.utils.book_append_sheet(workbook, worksheet, '用户数据')

      //   // 3. 生成Excel文件并保存
      //   // 写入工作簿，生成二进制数据
      //   const excelBuffer = XLSX.write(workbook, { 
      //     bookType: 'xlsx', // 文件类型：xlsx
      //     type: 'array'     // 输出类型：数组
      //   })
      //   // 将二进制数据转换为Blob对象
      //   const blob = new Blob([excelBuffer], {
      //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      //   })
      //   // 保存文件（文件名可自定义）
      //   fs.saveAs(blob, `用户数据_${new Date().getTime()}.xlsx`)
        
      //   this.$message.success('Excel导出成功！')
      // } catch (error) {
      //   console.error('Excel导出失败：', error)
      //   this.$message.error('Excel导出失败，请重试！')
      // }
  

  async  exportExcel() {
    // 下面以前导出代码
    const r = await  this.$confirm(`是否导出当前${this.infoData.pageSize}条记录?`)
    if (r == 'confirm') {
      const xlsxParam = { raw: true }
      let wb = null
      let tableName = ''
  
      const randomStringNum = this.randomString(6)
      wb = XLSX.utils.table_to_book(
        document.querySelector('#export-table1'),
        xlsxParam
      )
      tableName = `订单数据-${randomStringNum}.xlsx`

      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        fs.saveAs(new Blob([wbout], {
          type: 'application/octet-stream'
        }), tableName)
      } catch (e) {
        // if (typeof console !== 'undefined') {
        //   console.log(e, wbout)
        // }
      }
      return wbout    
     }
      // 导出的内容只做解析，不进行格式转换
     
    },

    getTime(n) {
      const date = new Date()
      date.setTime(date.getTime() + n * 24 * 60 * 60 * 1000)
      const year = date.getFullYear()
      let month = `${date.getMonth() + 1}`
      let day = `${date.getDate()}`
      if (Number(month) < 10) month = `0${month}`
      if (Number(day) < 10) day = `0${day}`
      return `${year}-${month}-${day}`
    },
    getToday() {
      this.params.startDate = this.getTime(0)
      this.params.endDate = this.getTime(0)
    },
    async getMerchantList() {
      const res = await this.$post('admin/getMerchantList', {
        currentPage: 1,
        pageSize: 100,
        s_show: true
      })
      res.data.data.unshift({ s_name: '全部商家', _id: '' })
      this.merchantList = res.data.data
    },
    async getrestaurantList() {
      const res = await this.$post('admin/getrestaurantList', {
        currentPage: 1,
        pageSize: 100,
      })
      res.data.data.unshift({ server_name: '全部餐厅', id: '' })
      
      this.restaurantList = res.data.data
    },

    
    //获取列表
    async getList() {
      
      this.tableLoad = true;
      this.query.startTime = new Date(this.params.startDate + " 00:00:00").getTime()
      this.query.endTime = new Date(this.params.endDate + " 23:59:59").getTime()
      this.query.s_type && (this.query.shanghu_id = '')
      const res = await this.$post('admin/getorderlist', this.query)
      _this.tableLoad = false;
      if (res.errno === 0) {
        for (let i in res.data.data) {
          res.data.data[i]._createTime = this.$time(res.data.data[i]._createTime)
        }
        _this.infoData = res.data;
        _this.items = res.data.data;
        _this.total = res.data.count;
       
        
      }

    },
    async checkPay(e){
      const res = await this.$post('merchant/checkOrder',e)
      if(res.errno === 0){
        this.$message.success('操作成功')
        this.getList()
      }
    },
    async confirmOrder(e) {

      this.$confirm(`订单号${e.orderNum},是否完成当前订单?`).then(async r => {
        if (r == 'confirm') {
          const data = {}
          data.order_num = e.orderNum
          const res = await this.$post('merchant/confirmOrder', { order: data })
          const help = await this.$http('https://api.yuepaoda.sale/api/help/confirm', { id: e.help.id })
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          await this.getList()
        }
      })

    },
    async cancelOrder(e) {

      this.$confirm(`订单号${e.orderNum},是否取消当前订单?`).then(async r => {
        if (r == 'confirm') {
          const data = {}
          data.order_num = e.orderNum
          const res = await this.$post('merchant/cancelOrder', { order: data })
          const help = await this.$http('https://api.yuepaoda.sale/api/help/update/state', { id: e.help.id, state: 4, })
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          await this.getList()
        }
      })

    },
    //重置搜索
    resetSearch() {
      this.query.orderNum = '';
      this.query.status = '';
      this.getList();
    },

    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectedRows = val;
    },
  
    //获取id
    getIds() {
      let arr = [];
      for (let i in this.multipleSelection) {
        arr.push(this.multipleSelection[i].id)
      }
      return arr
    },

    //跳转页码
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getList();
    },

    //更新值
    changeMsg(e) {
      this.getList()
    }

  }
};
</script>
  